module.exports = __webpack_public_path__ + "static/media/increase.fb6a1b69.jpg";